import React, { useEffect, useState } from "react";
import styles from "./index.module.scss";
import ImageSubText from "../../common/components/ImageSubText";
import infinipathIcon from "../../assets/images/infinipath-logo.webp";
import programsIcon from "../../assets/images/Programicons.svg";
// import hdbIcon from "../../assets/images/hdbIcon.svg";
import HDB_ICON from "../../assets/images/hdb-icon.svg";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setSideNavId } from "../../reducers/SeekerReducer";
import { getItemInLocalStorage } from "../../services/localStorage";
// Menu items data with absolute URLs
const menuItems = [
  {
    id: "infinipath",
    text: "infinipath",
    selectedImageSrc: infinipathIcon,
    url: "sessions",
  },
  {
    id: "hdb",
    text: "HDB",
    selectedImageSrc: HDB_ICON,
    url: "/admin/action-cards",
  },
];

const menuItemsMahatria = [
  {
    id: "infinipath",
    text: "infinipath",
    selectedImageSrc: infinipathIcon,
    url: "sessions",
  },
  {
    id: "hdb",
    text: "HDB",
    selectedImageSrc: HDB_ICON,
    //Should be mofified later currently keeping it static for demo
    url: "/admin/action-cards",
  },
];

const menuItemsAdmin = [
  {
    id: "infinipath",
    text: "infinipath",
    selectedImageSrc: infinipathIcon,
    url: "sessions",
  },
  {
    id: "hdb",
    text: "HDB",
    selectedImageSrc: HDB_ICON,
    url: "/admin/action-cards",
  },
];

const PortalNavigation: React.FC = () => {
  const userRole = getItemInLocalStorage("seekerDetails")?.role || "";
  const [selectedItem, setSelectedItem] = useState<string>("infiniprayer");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleNavigation = (id: string, url: string) => {
    console.log("Navigating to:", id);
    setSelectedItem(id);
    dispatch(setSideNavId(id)); // Update the sideNavId in the state
    navigate(url);
  };
  const reqMenuItems =
    userRole === "mahatria"
      ? menuItemsMahatria
      : userRole === "admin"
        ? menuItemsAdmin
        : menuItems;

  //To set the initial selected item based on user role
  useEffect(() => {
    if (userRole === "mahatria") {
      setSelectedItem("hdb");
    } else {
      setSelectedItem("program");
    }
  }, []);

  return (
    <div
      className={
        selectedItem === "infinipath" ? styles.sideBarTop : styles.sidebar
      }
    >
      <div className={styles.sidebarMenu}>
        {reqMenuItems?.map((item) => (
          <div
            key={item.id}
            className={`${styles.menuItem} ${selectedItem === item.id ? styles.selected : ""}`}
            onClick={() => handleNavigation(item.id, item.url)}
          >
            <ImageSubText
              selectedImageSrc={item.selectedImageSrc}
              text={item.text}
              isSelected={selectedItem === item.id}
              containerClass={styles.imageSubTextContainer}
              imageContainerClass={styles.imageContainer}
              imageClass={styles.image}
              textClass={styles.text}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default PortalNavigation;
